import { render } from "./ProjectDetailImages.vue?vue&type=template&id=2a8c7cd5&scoped=true"
import script from "./ProjectDetailImages.vue?vue&type=script&lang=js"
export * from "./ProjectDetailImages.vue?vue&type=script&lang=js"

import "./ProjectDetailImages.vue?vue&type=style&index=0&id=2a8c7cd5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8c7cd5"]])

export default __exports__